import { onUpdateExtractorSession } from "common/signalR";
import ListTemplate from "components/ListTemplate";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React, { useEffect } from "react";
import { useLoaderData } from "react-router";
import TrainModal from "train/TrainModal";
import { AIAssistantPanel } from "../AIAssistantPanel";
import { cardLayout } from "./cardLayout";
import Filters from "./Filters";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import confetti from "canvas-confetti";
import { CreditBalance } from "components/Credits/CreditBalance";

const ExtractorSessionListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ExtractorSessionListFrontModel>();

  useEffect(() => {
    const res = onUpdateExtractorSession(newItem => {
      if (newItem.lifeCycle === "waitingForUserAction") {
        confetti({
          particleCount: 100,
          spread: 70,
          origin: { y: 0.6 }
        });
      }
    });

    return () => {
      res.removeEvent();
    }
  }, []);

  return <>
    <TrainModal />
    <TwoColumnLayout classes="margin-bottom-larger">
      <TwoColumnLayout.LeftColumn>
        <AIAssistantPanel />
      </TwoColumnLayout.LeftColumn>
      <TwoColumnLayout.RightColumn>
        <CreditBalance />
      </TwoColumnLayout.RightColumn>
    </TwoColumnLayout>
    <ListTemplate
      title="Data extraction sessions"
      filterSet="extractorSession_List"
      defaultFilters={viewModel.defaultFilters}
      initialInstruction={viewModel.initialInstruction}
      fetchFunction={window.CoreApi.Extractor.Paginated}
      getId={item => item.extractorSessionId}
      layout={cardLayout()}
      filters={<Filters />}
      functions={{
        mapFilterValuesToInstruction,
        mapResponseToFilterValues
      }}
    />
  </>
};

export default ExtractorSessionListApp;
